import React, { useEffect } from 'react';
import { addReducer } from 'reactn';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { useApolloClient, useQuery, gql } from '@apollo/client';
import { Spinner } from 'equasion-lib';
import ErrorBoundary from '@/lib/shared-coms/ErrorBoundary';
import App from './App';
import { LOCAL_API_ORIGIN } from '@/lib/utils/localApiOrigin';

const ENV_SERVER = window.location.origin.includes('localhost')
  ? LOCAL_API_ORIGIN
  : window.location.origin;

const CURRENT_USER = gql`
  query currentUser {
    currentUser {
      id
      firstName
      lastName
    }
  }
`;

// LogRocket.init('zxed4g/wellgistics');
// setupLogRocketReact(LogRocket);

function AppData() {
  const client = useApolloClient();
  const { error, loading, data, refetch } = useQuery(CURRENT_USER, {
    fetchPolicy: 'network-only'
  });

  useEffect(() => {
    if (refetch) addReducer('login', refetch);
  }, [refetch]);

  useEffect(() => {
    addReducer('logout', async () => {
      await fetch(`${ENV_SERVER}/api/logout`, { credentials: 'include' });
      await client.clearStore();
      await refetch();
      return {
        userSession: null
      };
    });
  }, []);

  // useEffect(() => {
  //   if (data && data.currentUser) {
  //     const { firstName, lastName } = data.currentUser || {};
  //     LogRocket.identify(`${firstName} ${lastName}`);
  //   }
  // }, [data]);

  if (loading) return <Spinner />;
  if (error) return <ErrorBoundary error={error} />;

  return <App foundCurrentUser={data.currentUser} refetch={refetch} />;
}

export default AppData;
